import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { HTTP_HEADERS } from '@core/constants';

@Injectable()
export class UiCultureInterceptor implements HttpInterceptor {
    constructor(private translocoService: TranslocoService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const activeLang = this.translocoService.getActiveLang();

        if (!activeLang) {
            return next.handle(req);
        }

        const culturedReq = req.clone({
            setHeaders: {
                [HTTP_HEADERS.UI_CULTURE]: activeLang
            }
        });

        return next.handle(culturedReq);
    }
}
